// TenantQueryContext — derived by MCP middleware from AuthenticatedUser.
// Carries the two values VectorStorePort.query() must receive
// (tenantNamespace + allowedCollections) plus the role for downstream tier
// gating. Never built outside middleware.
import { z } from "zod";
import { CapabilitySchema } from "../shared-kernel/Capability.js";
import { RoleSchema } from "../shared-kernel/Role.js";
import { TenantNamespaceSchema } from "../shared-kernel/TenantNamespace.js";
export const TenantQueryContextSchema = z.object({
    tenantNamespace: TenantNamespaceSchema,
    allowedCollections: z.array(z.string().min(1)).min(1),
    role: RoleSchema,
    // [S-274] Optional principal hint for precedent-visibility enforcement. The
    // caller's uid (owner check) + capabilities (BA tier) — `role` is above and
    // `studioId` derives from the namespace. When absent, precedent visibility
    // enforcement fails CLOSED (only `tenant`-tier precedents surface), so a read
    // path that forgets to populate it over-hides rather than leaks.
    viewerUid: z.string().min(1).optional(),
    viewerCapabilities: z.array(CapabilitySchema).nullish(),
});
/** [S-772] A minimal TenantQueryContext from a tenant id, for lookups that
 *  scope by namespace only (ClauseReviewService.activeForChat reads
 *  `tenantNamespace`; `role` / `allowedCollections` are not consulted — the
 *  benign defaults satisfy the schema). Moved verbatim from ChatService.ts,
 *  where it was private, so the procedure adapter and V1 share one copy.
 *  Chat is always tenant-scoped, so `tenant-X` maps back to `studio-X`. */
export function ctxFromTenantId(tenantId) {
    const ns = tenantId.startsWith("tenant-")
        ? `studio-${tenantId.slice("tenant-".length)}`
        : "layer1";
    return {
        tenantNamespace: ns,
        allowedCollections: [`${ns}-contracts`],
        role: "tenant_user",
    };
}
//# sourceMappingURL=TenantQueryContext.js.map